var _path, _path2, _path3, _path4, _g, _g2, _path5, _g3, _g4, _path6, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStep03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95.3 86",
    enableBackground: "new 0 0 95.3 86",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M15.7,38h6.2c-0.9-1-1.6-2-2.3-3H15c-0.8,0-2.3,0.6-2.3,1.4V44h3V38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M27.8,76.2L27.8,76.2c0-0.8,0.2-1.6,0.5-2.2H16v-9h-3v10.7c0,0.8,1.2,1.3,2,1.3h12.8 C27.8,76.8,27.8,76.5,27.8,76.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M63.1,35h-3.8c-0.7,1-1.5,2-2.3,3H62v36H42.1c0.2,0.5,0.4,1.1,0.4,1.7c0,0.4-0.1,0.9-0.2,1.3h20.7 c0.8,0,1.9-0.4,1.9-1.3V36.4C65,35.6,63.9,35,63.1,35z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M39.6,42.5C28.2,42.5,19,33.3,19,21.9c0-11.3,9.2-20.6,20.6-20.6c11.3,0,20.6,9.2,20.6,20.6 C60.1,33.3,50.9,42.5,39.6,42.5z M39.6,4.4C29.9,4.4,22,12.3,22,21.9c0,9.7,7.9,17.6,17.6,17.6c9.7,0,17.6-7.9,17.6-17.6 C57.1,12.3,49.2,4.4,39.6,4.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M28.8,29.6c-0.6,0-1.1-0.3-1.4-0.9c-0.3-0.8-0.2-1.6,0.6-2l10.7-5V13c0-0.8,0.7-1.5,1.5-1.5 s1.5,0.7,1.5,1.5v9.7c0,0.6-0.2,1.1-0.7,1.4l-11.7,5.4C29.1,29.6,29,29.6,28.8,29.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M93.1,57l-9.9-12.9c-0.3-0.4-0.7-0.6-1.2-0.6H63.5c-0.8,0-1.5,0.7-1.5,1.5v30.5c0,0.8,0.7,1.5,1.5,1.5h7.2 c-0.3-1-0.3-2,0-3H65V46.5h16.4l9.1,11.9V74h-5.5c0.5,0.9,0.7,2,0.6,3h6.4c0.8,0,1.5-0.7,1.5-1.5V57.9C93.4,57.6,93.3,57.3,93.1,57 z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M77.5,85.5c-5,0-9.1-4.1-9.1-9.1s4.1-9.1,9.1-9.1s9.1,4.1,9.1,9.1S82.6,85.5,77.5,85.5z M77.5,70.3 c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1S80.9,70.3,77.5,70.3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M90,60H64c-0.8,0-1.5-0.7-1.5-1.5S63.2,57,64,57h26c0.8,0,1.5,0.7,1.5,1.5S90.8,60,90,60z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M31.4,69H15c-0.8,0-1.5,0.7-1.5,1.5S14.2,72,15,72h14.7C29.9,70.8,30.4,69.7,31.4,69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M62,69H38.1c1.3,0.6,2,1.7,2.4,3H62c0.8,0,1.5-0.7,1.5-1.5S62.8,69,62,69z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M35.3,85.5c-5,0-9.1-4.1-9.1-9.1s4.1-9.1,9.1-9.1s9.1,4.1,9.1,9.1S40.3,85.5,35.3,85.5z M35.3,70.3 c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1S38.7,70.3,35.3,70.3z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M27,50H13c-0.8,0-1.5-0.7-1.5-1.5S12.2,47,13,47h14c0.8,0,1.5,0.7,1.5,1.5S27.8,50,27,50z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M21,56H8c-0.8,0-1.5-0.7-1.5-1.5S7.2,53,8,53h13c0.8,0,1.5,0.7,1.5,1.5S21.8,56,21,56z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M16,62H3c-0.8,0-1.5-0.7-1.5-1.5S2.2,59,3,59h13c0.8,0,1.5,0.7,1.5,1.5S16.8,62,16,62z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M40.2,7.5c-0.8,0-1.5-0.7-1.5-1.5V3c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v3C41.7,6.8,41,7.5,40.2,7.5z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M39.2,41.5c-0.8,0-1.5-0.7-1.5-1.5v-3c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v3 C40.7,40.8,40,41.5,39.2,41.5z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M58,24h-3c-0.8,0-1.5-0.7-1.5-1.5S54.2,21,55,21h3c0.8,0,1.5,0.7,1.5,1.5S58.8,24,58,24z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M24,23h-3c-0.8,0-1.5-0.7-1.5-1.5S20.2,20,21,20h3c0.8,0,1.5,0.7,1.5,1.5S24.8,23,24,23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep03);
export default __webpack_public_path__ + "static/media/icon-step03.440801ea69d0ba658eca432524c23d23.svg";
export { ForwardRef as ReactComponent };